import { useMedia } from 'react-use';

export const tabletWidth = 768;
export const desktopWidth = 992;

export const useIsTablet = () => useMedia(`(min-width: ${tabletWidth}px)`);
export const useIsDesktop = () => useMedia(`(min-width: ${desktopWidth}px)`);
